module.exports = __webpack_public_path__ + "media/images/donation/ribbon-image-bb6923c2363db842a70afdecdebddbe1.jpg";